import { OrderRestriction, RestaurantMinMaxOrder } from '../models/restaurant.model';

export const dataToMinMaxRestrictions = (data: any): RestaurantMinMaxOrder => {
  return new RestaurantMinMaxOrder(
    dataToRestriction(data.pickup_texts),
    dataToRestriction(data.curbside_texts),
    dataToRestriction(data.tableside_texts),
    dataToRestriction(data.tab_ordering_texts),
    dataToRestriction(data.delivery_texts),
    dataToRestriction(data.x_side_texts),
  );
};
export const dataToRestriction = (data: any): OrderRestriction => {
  return new OrderRestriction(
    data.minimum_amount_in_cents ? data.minimum_amount_in_cents : 0,
    data.maximum_amount_in_cents ? data.maximum_amount_in_cents : 0
  );
};
